<div class="modal-header">
    <h4 class="modal-title">Information</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="close(false)"></button>
</div>
<div class="modal-body">
    <p style="color: red;font-weight: bold;">{{ Message }}</p>
    <hr>
    <div class="card-body p-1" style="overflow: auto;">
        <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered" *ngIf="Dataa && Dataa.length > 0">
            <thead *ngIf="Dataa && Dataa.length > 0">
                <tr *ngIf="Dataa && Dataa.length > 0">
                    <th scope="col">#</th>
                    <th scope="col">SiteCode</th>
                    <th scope="col">SiteName</th>
                    <th scope="col">Designation</th>
                    <th scope="col">Duty</th>
                    <th scope="col">Shift</th>
                    <th scope="col">FromDate</th>
                </tr>
            </thead>
            <tbody *ngIf="Dataa && Dataa.length > 0">
                <tr *ngFor="let data of Dataa; let i = index">
                    <th scope="row">{{ i + 1 }}</th>
                    <td>{{data['SiteCode']}}</td>
                    <td>{{ data['SiteName'] }}</td>
                    <td>{{ data['DesignationName'] }}</td>
                    <td>{{ data['DutyName'] }}</td>
                    <td>{{ data['ShiftTitle'] }}</td>
                    <td>{{ data['FromDate'] }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" [disabled]="isDisabled" (click)="close(false)"><i
            class="bi bi-x" *ngIf="!isDisabled"></i>
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
        {{!isDisabled?'Close':'Loading...'}}</button>
</div>